"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _APButton = _interopRequireDefault(require("../../../../common/APButton"));
var _commonComponent = require("../../../../../propTypes/commonComponent");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var BuySellOrderButtonComponent = function BuySellOrderButtonComponent(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)('order'),
    t = _useTranslation.t;
  var baseClasses = props.baseClasses,
    handleSubmit = props.handleSubmit,
    submitting = props.submitting,
    disabled = props.disabled,
    isBuySide = props.isBuySide,
    VerificationRequiredComponent = props.VerificationRequiredComponent,
    hideKYC = props.hideKYC,
    product1Name = props.product1Name,
    product2Name = props.product2Name,
    customKYCmessage = props.customKYCmessage,
    disableKYCLinkUnderReview = props.disableKYCLinkUnderReview;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('confirm-button-container')
  }, /*#__PURE__*/_react["default"].createElement(_APButton["default"], {
    customClass: baseClasses(),
    onClick: handleSubmit,
    styleName: isBuySide ? _commonComponent.styleNames.additive : _commonComponent.styleNames.subtractive,
    disabled: disabled
  }, submitting ? t('Processing...') : t("".concat(isBuySide ? 'Buy' : 'Sell', " {{a}} with {{b}}"), {
    a: product1Name,
    b: product2Name
  })), !hideKYC && /*#__PURE__*/_react["default"].createElement(VerificationRequiredComponent, {
    customKYCmessage: customKYCmessage,
    disableKYCLinkUnderReview: disableKYCLinkUnderReview
  }));
};
BuySellOrderButtonComponent.propTypes = {
  baseClasses: _propTypes["default"].func.isRequired,
  handleSubmit: _propTypes["default"].func.isRequired,
  submitting: _propTypes["default"].bool.isRequired,
  disabled: _propTypes["default"].bool.isRequired,
  isBuySide: _propTypes["default"].bool.isRequired,
  VerificationRequiredComponent: _propTypes["default"].func,
  hideKYC: _propTypes["default"].bool,
  customKYCmessage: _propTypes["default"].string
};
BuySellOrderButtonComponent.defaultProps = {
  disableKYCLinkUnderReview: false
};
var _default = exports["default"] = BuySellOrderButtonComponent;